import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(VSnackbar,{attrs:{"timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c(VLayout,{attrs:{"align-center":"","pr-4":""}},[_c(VIcon,{staticClass:"pr-3",attrs:{"dark":"","large":""}},[_vm._v(_vm._s(_vm.icon))]),_c(VLayout,{attrs:{"column":""}},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.systemMessageTitle))])]),_c('div',[_vm._v(_vm._s(_vm.systemMessage))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }